module.exports = __webpack_public_path__ + "static/img/logo-blanco.cddc122.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-blanco.svg
// module id = zg4I
// module chunks = 41